import axios from 'axios';
import * as React from 'react';
import { requestNewMessages } from '../asyncHelpers/newMessagesService';
import { InboxItemsResponse } from '../sic-lib/api/newRecent/types/InboxItemsResponse';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncGetNewMessages
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestNewMessages HTTP request
 */
export default function useAsyncGetNewMessages() {
    const dispatch = useAppDispatch();
    const request_token = axios.CancelToken.source();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncGetNewMessages = async (
        clientId: number,
        userName: string,
    ): Promise<InboxItemsResponse | undefined> => {
        try {
            const dataObj = { clientId: clientId, userName: userName };

            setRequestStatus(RequestStatus.active);

            const { data } = await requestNewMessages(dataObj, request_token.token);

            setRequestStatus(RequestStatus.success);

            return data;
        } catch (e: any) {
            if (!axios.isCancel(e)) {
                if (axios.isAxiosError(e)) {
                    if (e.response?.status == 400) {
                        /* Notify user of failed http request */
                        const toastData = createErrorToast(e.response.data);

                        dispatch(createToast({ toastData }));
                    }
                }
                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncGetNewMessages,
    };
}
